import { NgModule } from '@angular/core';
import { RouterModule, Routes } from '@angular/router';

import { LoginComponent } from './login/login.component';
import { FullLayoutComponent } from './components/full-layout/full-layout.component';
import { AuthGuard } from './auth.guard';
import { BetaGuard } from './guards/beta.guard';
import { UnsavedChangesGuard } from './unsaved-changes.guard';
import { CommonService } from './services/common.service';
import { DashboardComponent } from './pages/dashboard/dashboard.component';
// import { TaxonomyDashboardComponent } from './pages/taxonomy-dashboard/taxonomy-dashboard.component';
import { CreateDashboardComponent } from './pages/user-dashboard/create-dashboard/create-dashboard.component';
import { ReportComponent } from './components/report/report.component';
import { TaxonomyDashboardV2Component } from './pages/taxonomy-dashboard-v2/taxonomy-dashboard-v2.component';
import { TaxonomyPageComponent } from './pages/taxonomy-dashboard-v2/taxonomy-page/taxonomy-page.component';
import { TaxonomySettingsComponent } from './pages/taxonomy-dashboard-v2/taxonomy-settings/taxonomy-settings.component';
import { NovaComponent } from './pages/nova/nova.component';
import { NovaStorageComponent } from './pages/nova/nova-storage/nova-storage.component';
import { UserDashboardComponent } from './pages/user-dashboard/user-dashboard.component';
import { LargeChartViewComponent } from './components/large-chart-view/large-chart-view.component';
import { TrendsDashboardComponent } from './pages/trends-dashboard/trends-dashboard.component';
import { FreeformCollectionDashboardComponent } from './pages/freeform-collection-dashboard/freeform-collection-dashboard.component';

export const routes: Routes = [
  {
    path: '',
    component: FullLayoutComponent,
    canActivate: [AuthGuard],
    children: [
      { path: '', loadChildren: () => [{ path: '', component: DashboardComponent }] },
      { path: 'conversation-insights', loadChildren: () => [{ path: '', component: DashboardComponent }] },
      {
        path: 'taxonomy-dashboard',
        loadChildren: () => [{ path: '', component: TaxonomyDashboardV2Component }],
      },
      {
        path: 'taxonomy-dashboard/all-taxonomies',
        loadChildren: () => [{ path: '', component: TaxonomyDashboardV2Component }],
      },
      {
        path: 'taxonomy-dashboard/playground',
        loadChildren: () => [{ path: '', component: TaxonomyDashboardV2Component }],
      },
      {
        path: 'taxonomy-dashboard/:id',
        loadChildren: () => [{ path: '', component: TaxonomyPageComponent }],
      },
      {
        path: 'user-dashboard',
        loadChildren: () => [{ path: '', component: UserDashboardComponent }],
      },
      {
        path: 'create-dashboard',
        component: CreateDashboardComponent,
        canDeactivate: [UnsavedChangesGuard]
      },
      {
        path: 'chart-view',
        loadChildren: () => [{ path: '', component: LargeChartViewComponent }],
      },
      {
        path: 'report',
        loadChildren: () => [{ path: '', component: ReportComponent }],
      },
      {
        path: 'settings',
        loadChildren: () => [{ path: '', component: TaxonomySettingsComponent }],
      },
      {
        path: 'nova',
        loadChildren: () => [{ path: '', component: NovaComponent }],
      },
      {
        path: 'nova/saved-files',
        loadChildren: () => [{ path: '', component: NovaStorageComponent }],
      },
      {
        path: 'nova/:id',
        loadChildren: () => [{ path: '', component: NovaComponent }],
      },
      {
        path: 'trends',
        loadChildren: () => [{ path: '', component: TrendsDashboardComponent }],
        canActivate: [BetaGuard],
      },
      {
        path: 'freeform-collection',
        loadChildren: () => [{ path: '', component: FreeformCollectionDashboardComponent }],
        canActivate: [BetaGuard],
      },
    ],
  },
  { path: 'login', component: LoginComponent },
  { path: '**', component: LoginComponent },
];

@NgModule({
  imports: [RouterModule.forRoot(routes)],
  providers: [CommonService, UnsavedChangesGuard],
  exports: [RouterModule],
})
export class AppRoutingModule {}
